import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api, {ListApiKeysParams} from 'src/services/api'

type Props = {
  params: ListApiKeysParams
  onError?: (error: unknown) => void
  enabled?: boolean
}

export default function useListApiKeys({params, onError, enabled = true}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: ['list-api-keys', params],
    queryFn: async () => (await api.auth.listApiKeys(params)).data.data.entities,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
